/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const LIST = 'LIST';
export const AREAS = 'AREAS';
export const FLOORS = 'FLOORS';
export const MEDIAS = 'MEDIAS';

export default {
  LIST,
  AREAS,
  FLOORS,
  MEDIAS,
};
